import store from '@/store';
export default {
    inserted(el, binding) {
        setTimeout(()=>{
            if (!store.getters.menuPageButtonList.includes(binding.value)) {
                el.remove()
            }
        },500)
    },
    update() {
    },
    unbind() {
    }
};